import React from "react";
import Footer from "./Footer";
import Header from "./Header";
import ErrorBoundary from "../ErrorBoundary";

type LayoutProps = {
  children: any;
  preLogin?: boolean;
};

const Layout: React.FC<LayoutProps> = ({
  children,
  preLogin,
}): React.ReactElement => {
  const PreLoginLayout = (
    <div className="flex flex-col h-screen w-full bg-white text-black">
      <div className="flex flex-col justify-center items-center flex-grow">
        {/* <ErrorBoundary /> */}
        {children}
      </div>
      {/* <Footer /> */}
    </div>
  );

  const PostLoginLayout = (
    <div className="flex flex-col h-screen w-full text-black bg-[#eff6ff] !relative !z-[999] dark:bg-[#1D2939]">
      <div className="flex flex-grow h-full overflow-hidden max-h-screen lg:p-6">
        {children}
      </div>
      {/* <Footer /> */}
    </div>
  );

  return preLogin ? PreLoginLayout : PostLoginLayout;
};

export default Layout;
